import { SearchDirection } from 'shared/api/excursions/search/model'

export const findExcursionInList = (
  id: string,
  listExcursions: SearchDirection[] | undefined,
) => {
  return listExcursions?.find((item) => item.id === id)
}
